import { BettingApi } from 'api';
import { StakeMethod } from 'api/betslipAnalytics.api';
import { ActiveFreebetDto, BetActionErrorResponseDataDto } from 'api/common.generated';
import CouponRemoveAllButton from 'features/coupon/component/CouponRemoveAllButton';
import CouponUndoButton from 'features/coupon/component/CouponUndoButton';
import PlaceBetSuccessDialog from 'features/coupon/component/PlaceBetSuccessDialog/PlaceBetSuccessDialog';
import { getUserOddsChangeRules } from 'features/coupon/utility';
import fetchInGameCouponCount from 'features/customerPanel/cpCoupons/store/cpCoupons.action';
import { handleBalanceData } from 'features/customerPanel/store/cpPanel.action';
import FastPayment from 'features/fastPayment';
import { Freebet } from 'features/offers/interface/offers.interface';
import { fetchBonusesAndFreebets } from 'features/offers/store/offers.action';
import { selectFreebetsActive } from 'features/offers/store/offers.selectors';
import { filterFreebets } from 'features/offers/utility/freebets';
import { removeBet, removeBets } from 'features/virtualSports/utils';
import WebView from 'features/webView/utils';
import isEmpty from 'lodash/isEmpty';
import { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import BottomDrawer from 'shared/components/BottomDrawer';
import { gameTypeIsBetBuilder } from 'shared/components/outcomeCards/gameTypeIds';
import { addNotification } from 'shared/components/toast';
import { AKO, APP_URL, BONUS_BALANCE, MAIN_BALANCE, SectionNavigation, SYSTEM } from 'shared/constants/common';
import { BetEvents, BetslipEvents, DATALAYER_PLACEBET_SUCCESS, setDataLayer } from 'shared/constants/datalayer';
import { BETSLIP_ANALYTICS_KEY, sendAnalytics } from 'shared/hooks/useBetslipAnalytics';
import { Action, BalanceState, BETSType, CouponState, PlaceBet, State } from 'shared/interface/index';
import { addBet, calculateTax, changeInBetOutcomes, createLoader, removeFreeBetStack } from 'shared/store/coupon.action';
import { DefaultBetslipState } from 'shared/store/coupon.reducer';
import { createIsActionLoadingSelector } from 'shared/store/loading.selectors';
import { formatBetErrorEvents } from 'shared/util/datalayerFormatting';
import { clearInactivityTimer } from 'shared/util/timer';
import { getBalanceDetails, getUserDetails, handleRemoveOverflow, isMobile, updateUserDetails } from 'shared/util/utility';
import InactiveUserDialog from '../../../shared/components/dialog/inactiveUserDialog';
import { getAnalyticalData } from '../../../shared/util/analytical';
import AcceptedBetSlipModal from '../component/acceptedBetslipModal';
import DesktopCouponBasket from '../component/DesktopCouponBasket';
import MobileCouponBasket from '../component/MobileCouponBasket';
import { BetslipErrors, SlipType } from '../interface';
import { ApprovedBetSlipData, ApprovedBetSlipStatus } from '../interface/coupon.interface';
import { checkIsGameModeChange, getBetTypeForSelectedBets, getOutcomesAndBlocksAfterChange } from '../utility';
import './styles.scss';

interface CouponWithBetsState {
	stackValue: number;
	acceptHigherOdds: boolean;
	acceptAnyOdds: boolean;
	selectedCombination: string;
	showCongratsModal: boolean;
	congratsModalBetStatics: any;
	balanceData: BalanceState;
	errorCode: number[];
	betActionErrors: BetActionErrorResponseDataDto[];
	freeBets: any[];
	selectedFreeBet: string;
	showDeleteModal: boolean;
	betLoading: boolean;
	approvedBetSlipData: ApprovedBetSlipData;
	approvedSlip: boolean;
	warnings: string[];
	completedEvents: string[];
	blocks: PlaceBet[][];
	bankerBets: PlaceBet[];
	temporaryBets: any;
	isRestoringBets: boolean;
	isCal: boolean;
	inactiveUserModalOpen: boolean;
	isFastPaymentReady: boolean;
	stake_method: string;
}

interface Props extends WithTranslation, MapStateProps, DispatchProps, RouteComponentProps {
	changeNavigationView(view: SectionNavigation): void;
}

class CouponWithBets extends Component<Props, CouponWithBetsState> {
	state: CouponWithBetsState = {
		stackValue: this.props.bets.stake,
		selectedCombination: !this.props.bets.betType ? '1' : String(this.props.bets.betType),
		showCongratsModal: false,
		congratsModalBetStatics: {},
		balanceData: this.props.balanceData,
		errorCode: [],
		betActionErrors: [],
		freeBets: [],
		selectedFreeBet: '',
		showDeleteModal: false,
		betLoading: false,
		approvedBetSlipData: {} as ApprovedBetSlipData,
		approvedSlip: false,
		warnings: [],
		completedEvents: [],
		blocks: [],
		bankerBets: [],
		temporaryBets: [],
		isRestoringBets: false,
		isCal: false,
		inactiveUserModalOpen: false,
		isFastPaymentReady: false,
		stake_method: StakeMethod.DEFAULT,
		...getUserOddsChangeRules(),
	};

	intervalId: any;
	approvedBetSlipInterval: any;

	componentDidMount() {
		if (this.props.bets && this.props.bets.isFreeBetSelected && this.state.selectedFreeBet === '') {
			this.setState({ selectedFreeBet: this.props.bets?.freebetId?.toString() || '' });
		}
		const allBets = [...this.props.bets.blocks, ...this.props.bets.outcomes].flat();
		if (allBets.length) {
			this.props.calculateTax();
		}
		this.intervalId = setInterval(() => {
			if (allBets.length > 0 && allBets.some((item) => item.isLive)) {
				this.props.calculateTax();
			}
		}, 30000);
		this.filterFreeBets();
	}

	setStakeMethod = (stake: string) => this.setState({ stake_method: stake });

	componentDidUpdate(prevProps: any) {
		if (this.props.bets && this.props.bets.isFreeBetSelected && this.state.selectedFreeBet === '') {
			this.setState({ selectedFreeBet: this.props.bets?.freebetId?.toString() || '' });
		}
		this.calculateTaxOnInterval();
		const totalNonBankerSlipsInBetslip = this.props.bets?.outcomes?.filter((outcome) => !outcome.banker).length + this.props.bets?.blocks?.length;
		const totalNonBankerSlipsFromPrevProps =
			prevProps.bets?.outcomes?.filter((outcome: PlaceBet) => !outcome.banker).length + prevProps.bets?.blocks?.length;

		const isCombinationsChangeLimitReached =
			prevProps.bets?.outcomes.length > this.props.bets?.outcomes.length ||
			(totalNonBankerSlipsFromPrevProps === 12 && totalNonBankerSlipsInBetslip > 12);

		if (this.props.bets?.betMode === SYSTEM && isCombinationsChangeLimitReached) {
			this.handleSelectedCombination('1');
		}

		if (
			(prevProps.bets?.outcomes?.length === 0 && this.props.bets?.outcomes?.length > 0) ||
			(prevProps.freebetsActive?.length === 0 && this.props.freebetsActive?.length > 0)
		) {
			this.filterFreeBets();
		}
	}

	calculateTaxOnInterval = () => {
		const allBets = [...this.props.bets.blocks, ...this.props.bets.outcomes].flat();

		if (allBets.length > 0 && allBets.some((item) => item.isLive) && !this.intervalId) {
			this.intervalId = setInterval(() => {
				this.props.calculateTax();
			}, 30000);
		}

		if (allBets.filter((bet) => !bet.isLive).length === allBets.length) {
			clearInterval(this.intervalId);
			this.intervalId = null;
		}
	};

	static getDerivedStateFromProps(nextProps: MapStateProps) {
		if (nextProps.bets.outcomes.length === 0) {
			return {
				errorCode: [],
				errorDetail: [],
			};
		}
		return null;
	}

	componentWillUnmount() {
		clearInterval(this.intervalId);
		clearInterval(this.approvedBetSlipInterval);
		isMobile() && handleRemoveOverflow();
	}

	filterFreeBets = (bets?: any) => {
		const freeBets = filterFreebets(
			this.props.freebetsActive,
			(bets || this.props.bets.outcomes).filter((item: any) => item.selectedBet),
		);

		const selectedFreeBet = freeBets.filter((freeBet) => freeBet.offerFreebetId.toString() === this.state.selectedFreeBet);

		if (!isEmpty(selectedFreeBet)) {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			this.handelSelectedFreeBet(selectedFreeBet[0]!.offerFreebetId.toString(), selectedFreeBet[0]!.freebetStake);
		} else {
			this.setState({ selectedFreeBet: '' });
		}
		this.setState({ freeBets });
	};

	onChangeGameMode = (mode: string) => {
		const akoStakeType = this.props.bets.outcomes.filter((item) => item.selectedBet);
		const betType = mode === AKO ? (akoStakeType.length > 1 ? SlipType.AKO : SlipType.SOLO) : this.state.selectedCombination;

		const outcomesInBetslip = [...this.props.bets.outcomes];
		const blocksInBetslip = [...this.props.bets.blocks];

		this.setState({
			blocks: blocksInBetslip,
		});

		const blocks = [...this.state.blocks];
		const outcomeIdOfSlipsInBlocks = blocks.map((block) => block.map((bet: PlaceBet) => bet.outcomeId)).flat();

		const betsForAko = [...blocksInBetslip.flat(), ...outcomesInBetslip];

		const outcomes = betsForAko.filter((bet) => !outcomeIdOfSlipsInBlocks.includes(bet.outcomeId));

		const addBet = (outcomes: PlaceBet[], blocks: PlaceBet[][]) => {
			this.props.addBet({
				...this.props.bets,
				outcomes,
				blocks,
				betMode: mode,
				betType: Number(betType),
			});
		};

		if (mode === AKO) {
			addBet(betsForAko, []);
		} else {
			addBet(outcomes, blocks);
		}
	};

	onChangeStackValue = (value: number) => {
		this.setState({
			stackValue: value,
			errorCode: [],
		});
		this.props.addBet({ ...this.props.bets, stake: value });
	};

	removeBet = (outcomeId: string) => {
		let targetBet = {};

		const blocksInBetslip = [...this.props.bets.blocks];
		const outcomesInBetslip = [...this.props.bets.outcomes];
		const betMode = this.props.bets.betMode;

		const blocksWithoutTargetBet = blocksInBetslip.map((block) => block.filter((bet: PlaceBet) => bet.outcomeId !== outcomeId));
		targetBet = blocksInBetslip.map((block) => block.find((bet) => bet.outcomeId === outcomeId));

		const outcomesWithoutTargetBet = outcomesInBetslip.flat().filter((bet) => bet.outcomeId !== outcomeId);

		if (betMode === AKO) {
			const selectedBet = outcomesWithoutTargetBet.filter((bet) => bet.selectedBet);
			if (selectedBet.length === 0) {
				outcomesWithoutTargetBet.forEach((bet) => (bet.selectedBet = true));
				this.setDefaultBetslipState();
			} else {
				const betType = getBetTypeForSelectedBets(outcomesWithoutTargetBet);
				this.props.addBet({
					...this.props.bets,
					outcomes: outcomesWithoutTargetBet,
					betType,
				});
			}
		} else {
			const outcomes = getOutcomesAndBlocksAfterChange(blocksWithoutTargetBet, outcomesWithoutTargetBet).outcomes;
			const blocks = getOutcomesAndBlocksAfterChange(blocksWithoutTargetBet, outcomesWithoutTargetBet).blocks;

			const changeToAko = checkIsGameModeChange(outcomes, blocks, outcomesWithoutTargetBet);

			if (changeToAko) {
				const outcomesForAko = [...blocks, ...outcomes].flat();
				const betType = getBetTypeForSelectedBets(outcomesForAko);

				outcomesForAko.forEach((outcome) => (outcome.banker = false));
				this.props.addBet({
					...this.props.bets,
					outcomes: outcomesForAko,
					blocks: [],
					betMode: AKO,
					betType,
				});
			} else {
				this.props.addBet({
					...this.props.bets,
					blocks,
					outcomes,
					betType: Number(this.state.selectedCombination),
				});
			}
		}

		// this.filterFreeBets(outcomesWithoutTargetBet);
		this.props.createLoader();

		if (this.props.location.pathname === APP_URL.virtualSports) {
			removeBet(targetBet);
		}
	};

	handelSelectedBet = (isSelected: boolean, outcomeId: string) => {
		const outcomes = [...this.props.bets.outcomes];
		const allBets = [...this.props.bets.blocks, ...this.props.bets.outcomes];
		const betsForSystem = allBets.flat();

		const indexForAko = outcomes.findIndex((item) => item.outcomeId === outcomeId);
		const indexForSystem = betsForSystem.findIndex((item) => item.outcomeId === outcomeId);

		if (this.props.bets.betMode === AKO) {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			outcomes[indexForAko]!.selectedBet = isSelected;
		} else {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			betsForSystem[indexForSystem]!.banker = isSelected;
		}

		if (this.props.bets.betMode === AKO) {
			const freeBets = filterFreebets(
				this.props.freebetsActive,
				(outcomes || this.props.bets.outcomes).filter((item: any) => item.selectedBet),
			);
			const selectedFreeBet = freeBets.filter((freeBet) => freeBet.offerFreebetId.toString() === this.state.selectedFreeBet);
			const betType = getBetTypeForSelectedBets(outcomes);

			if (!isEmpty(selectedFreeBet)) {
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				this.handelSelectedFreeBet(selectedFreeBet[0]!.offerFreebetId.toString(), selectedFreeBet[0]!.freebetStake);
				this.props.addBet({ ...this.props.bets, outcomes });
			} else {
				this.setState({
					selectedFreeBet: '',
					stackValue: this.props.bets.stake,
					errorCode: [],
				});
				this.props.addBet({
					...this.props.bets,
					outcomes,
					stake: this.props.bets.stake,
					freeBetStack: null,
					isFreeBetSelected: false,
					betType,
				});
			}

			this.setState({ freeBets });
		} else {
			this.setState({ selectedCombination: '1' });

			if (isSelected) {
				this.handleGroupChange(outcomeId, -1);
			} else {
				this.props.addBet({ ...this.props.bets, outcomes, betType: 1 });
			}

			this.props.createLoader();
		}
	};

	handleGroupChange = (outcomeId: string, newGroupIndex?: number) => {
		const bankerBets = this.props.bets.outcomes.filter((outcome) => outcome.banker);
		const nonBankerBets = this.props.bets.outcomes.filter((outcome) => !outcome.banker);

		this.setState({
			bankerBets: bankerBets,
		});

		const allGroups = [...this.props.bets.blocks, ...nonBankerBets.map((outcome) => [outcome]), []];

		const index = newGroupIndex === -1 ? allGroups.length - 1 : newGroupIndex;

		const betToMove = allGroups.flat().find((bet: PlaceBet) => bet.outcomeId === outcomeId);
		const filteredGroups = allGroups.map((group) => group.filter((bet: PlaceBet) => bet.outcomeId !== outcomeId));

		if (index !== undefined && betToMove) {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			filteredGroups[index]!.push(betToMove);
		}

		const newOutcomes = filteredGroups.filter((group) => group.length === 1).flat();

		const outcomes = [...bankerBets, ...newOutcomes];
		const blocks = filteredGroups.filter((group) => group.length > 1);

		blocks.map((block) => block.forEach((bet: PlaceBet) => (bet.banker = false)));

		const changeToAko = checkIsGameModeChange(outcomes, blocks);

		if (changeToAko) {
			const akoBets = [...blocks, ...outcomes].flat();
			const betType = getBetTypeForSelectedBets(akoBets);

			akoBets.forEach((bet) => (bet.banker = false));
			this.props.addBet({
				...this.props.bets,
				betMode: AKO,
				betType,
				outcomes: akoBets,
				blocks: [],
			});
		} else {
			this.props.addBet({
				...this.props.bets,
				betType: parseInt(this.state.selectedCombination),
				outcomes,
				blocks,
			});
		}
	};

	handleOddsChangeOption = (value: string) => {
		localStorage.setItem('oddsChangeRule', value);
		this.props.addBet({ ...this.props.bets, ...getUserOddsChangeRules() });
	};

	handleSelectedCombination = (value: string) => {
		this.setState({
			selectedCombination: value,
		});
		this.props.addBet({ ...this.props.bets, betType: parseInt(value) });
		this.props.createLoader();
	};

	handleMaxPossibleReturnError = (errorResponseList: BetActionErrorResponseDataDto[], selectedFreeBet: number): BetActionErrorResponseDataDto[] => {
		return errorResponseList.map((error) => {
			if (error.betSlipErrorCode === BetslipErrors.MAX_POSSIBLE_RETURN) {
				const updatedError = { ...error };
				if (updatedError.errorDetails?.expected) {
					updatedError.errorDetails.expected = String(Number(updatedError.errorDetails.expected) - selectedFreeBet);
				}
				return updatedError;
			}
			return error;
		});
	};

	onClickPlaceBet = async () => {
		this.setState({
			betLoading: true,
		});
		let obj: any;

		const unsentBetslipAnalytics = localStorage.getItem(BETSLIP_ANALYTICS_KEY);

		if (unsentBetslipAnalytics) {
			clearInactivityTimer();
			await sendAnalytics(JSON.parse(unsentBetslipAnalytics));
		}
		const userData = getUserDetails();
		if (this.props.bets.betMode === AKO) {
			const betType = getBetTypeForSelectedBets(this.props.bets.outcomes);
			const outcomes = [
				...this.props.bets.outcomes.map((item) => ({
					outcomeId: item.outcomeId,
					outcomeOdds: item.outcomeOdds,
					banker: false,
					sportId: item.sportId,
					eventId: item.eventId,
					eventType: item.eventType,
					selectedBet: item.selectedBet,
				})),
			];
			obj = {
				stake: this.props.bets.isFreeBetSelected ? this.props.bets.freeBetStack : this.props.bets.stake,
				betType,
				addAccumulator: this.props.bets.addAccumulator,
				acceptHigherOdds: this.props.bets.acceptHigherOdds,
				acceptAnyOdds: this.props.bets.acceptAnyOdds,
				outcomes: outcomes,
				currencyCode: 'PLN',
				bonusBet: false,
				blocks: [],
			};

			const balanceData = getBalanceDetails();

			if (this.state.selectedFreeBet) {
				obj = { ...obj, freebetId: parseInt(this.state.selectedFreeBet) };
			} else {
				if (!this.state.selectedFreeBet && balanceData.selectedBalanceType === BONUS_BALANCE) {
					obj = {
						...obj,
						bonusBet: true,
						blocks: obj.blocks || [],
						wagerBonusId: !isEmpty(balanceData.bonusBalanceList) ? balanceData.bonusBalanceList[0].wagerBonusId.toString() : '',
					};
				}
			}
		} else {
			const outcomes = [
				...this.props.bets.outcomes.map((item) => ({
					outcomeId: item.outcomeId,
					outcomeOdds: item.outcomeOdds,
					banker: item.banker,
					sportId: item.sportId,
					eventId: item.eventId,
					eventType: item.eventType,
				})),
			];
			const blocks = this.props.bets.blocks.map((block) =>
				block.map((item) => ({
					outcomeId: item.outcomeId,
					outcomeOdds: item.outcomeOdds,
					banker: item.banker,
					sportId: item.sportId,
					eventId: item.eventId,
					eventType: item.eventType,
				})),
			);
			obj = {
				stake: this.props.bets.isFreeBetSelected ? this.props.bets.freeBetStack : this.props.bets.stake,
				betType: parseInt(this.state.selectedCombination),
				addAccumulator: this.props.bets.addAccumulator,
				acceptHigherOdds: this.props.bets.acceptHigherOdds,
				acceptAnyOdds: this.props.bets.acceptAnyOdds,
				outcomes: outcomes,
				currencyCode: 'PLN',
				bonusBet: false,
				blocks: blocks || [],
			};
		}

		try {
			const isPreMatch = isEmpty(this.props.bets.outcomes.filter((item) => item.isLive === true));
			if (isPreMatch) {
				obj = {
					...obj,
					addAccumulator: false,
					acceptHigherOdds: false,
					acceptAnyOdds: false,
				};
			}
			const response = await BettingApi.betPlace(obj);

			if (!response.data.isError) {
				const { newBalance, newBonusBalance } = response.data.data.slipData;
				const { coupon_events, coupon_events_removed } = response.data.data.analyticsData;

				const {
					bet_balance_type,
					outcome_url,
					total_odds,
					bet_type,
					bet_potential_win,
					balance_before_coupon,
					balance_after_coupon,
					bet_bonus_balance,
					coupon_type,
				} =
					// @ts-ignore
					getAnalyticalData(this.props);
				const balanceData = getBalanceDetails();
				const bonusBalance = newBonusBalance ?? balanceData.bonusBalance;
				this.setState({
					showCongratsModal: true,
					congratsModalBetStatics: this.props.betStatics,
					betActionErrors: [],
					betLoading: false,
					warnings: [],
					completedEvents: [],
				});

				setDataLayer({
					...DATALAYER_PLACEBET_SUCCESS,
					...userData,
					lastStake: this.props.bets.isFreeBetSelected ? this.props.bets.freeBetStack : this.props.bets.stake,
				});

				if (bet_type !== 'system') {
					setDataLayer(
						BetslipEvents.BET_SUCCESS({
							is_premade_betbuilder: this.props.bets.outcomes.some((outcome: PlaceBet) =>
								gameTypeIsBetBuilder(Number(outcome.gameType)),
							),
							balance_before_coupon,
							balance_after_coupon,
							bet_bonus_balance,
							coupon_type,
							bet_balance_type,
							stake_method: this.state.stake_method,
							bet_value:
								this.props.bets.isFreeBetSelected && this.props.bets.freeBetStack
									? this.props.bets.freeBetStack
									: this.props.bets.stake,
							origin_url: outcome_url,
							total_events: coupon_events.length,
							total_events_removed: coupon_events_removed.length,
							bet_potential_win,
							bet_type,
							total_odds,
							coupon_events,
							coupon_events_removed,
						}),
					);
				}
				WebView.broadcastAnalytics('PLACED_BET');

				updateUserDetails('lastStake', this.state.stackValue);
				this.props.handleBalanceData({
					...balanceData,
					mainBalance: newBalance,
					bonusBalance,
				});
				if (!newBonusBalance) {
					this.props.handleBalanceData({
						...balanceData,
						selectedBalanceType: MAIN_BALANCE,
					});
				}
				if (this.state.selectedFreeBet || newBonusBalance || newBonusBalance === 0) {
					this.props.fetchBonusesAndFreebets();
				}
				this.props.fetchInGameCouponCount();
			} else {
				const errorCode = response.data.data.map((item: any) => item.betSlipErrorCode);
				let localbetActionErrors: BetActionErrorResponseDataDto[] = [];
				const dataLayerErrors = formatBetErrorEvents(response.data.data, this.props.t);
				BetEvents.ERROR({ bet_error_codes: dataLayerErrors });
				if (errorCode.includes(BetslipErrors.TEMPORARY_ACCOUNT_TIME_LIMIT_REACHED)) {
					this.setState({ inactiveUserModalOpen: true });
				}

				// risk monitering
				if (
					errorCode.includes(BetslipErrors.SINGLE_SLIP_TO_ACCEPT_FOR_TRADER) ||
					errorCode.includes(BetslipErrors.MULTI_SLIP_TO_ACCEPT_FOR_TRADER)
				) {
					const isApproved = await this.getApproveBets(obj);

					if (isApproved) {
						this.checkApprovedSlips();
						this.approvedBetSlipInterval = setInterval(() => {
							this.checkApprovedSlips();
						}, 8000);
					}
					return;
				}

				// errorcodes where we show black borders around the bet card
				if (
					errorCode.includes(BetslipErrors.GAME_UNAVAILABLE) ||
					errorCode.includes(BetslipErrors.EVENT_UNAVAILABLE) ||
					errorCode.includes(BetslipErrors.GAME_OUTCOME_UNAVAILABLE) ||
					errorCode.includes(BetslipErrors.CATEGORY_LEVEL_1_UNAVAILABLE) ||
					errorCode.includes(BetslipErrors.CATEGORY_LEVEL_2_UNAVAILABLE) ||
					errorCode.includes(BetslipErrors.CATEGORY_LEVEL_3_UNAVAILABLE)
				) {
					const checkOddsChange = await BettingApi.taxCalculation(obj);
					const refreshedOdds = checkOddsChange.data.data.refreshedOdds;
					const bets = obj;
					const warnings: string[] = [];
					refreshedOdds.forEach((item: any) => {
						const index = bets.outcomes.findIndex((bet: any) => bet.outcomeId === item.outcomeId);
						if (index !== -1 && item.outcomeOdds !== bets.outcomes[index].outcomeOdds) {
							if (bets.acceptHigherOdds && item.outcomeOdds < bets.outcomes[index].outcomeOdds) {
								warnings.push(item.outcomeId.toString());
							} else if (!bets.acceptAnyOdds && !bets.acceptHigherOdds) {
								warnings.push(item.outcomeId.toString());
							}
						}
					});
					const errorDetails = response.data.data.map((item: any) => item.errorDetails);
					const completedEvents = errorDetails.map((item: any) => String(item.outcomeId));
					this.setState({ betLoading: false, completedEvents, warnings });
				}

				// errorcodes where we show orange borders around the bet card
				if (errorCode.includes(BetslipErrors.ODDS_CHANGED)) {
					this.props.calculateTax();
					const errorDetails = response.data.data.map((item: any) => item.errorDetails);
					const warnings = errorDetails.map((item: any) => item.outcomeId);
					this.props.changeInBetOutcomes(errorDetails);
					this.setState({ betLoading: false, warnings });
				}
				if (errorCode.includes(BetslipErrors.MAX_POSSIBLE_RETURN)) {
					const selectedFreeBet: ActiveFreebetDto = this.state.freeBets.find(
						(freeBet) => freeBet.offerFreebetId.toString() === this.state.selectedFreeBet,
					);
					localbetActionErrors = this.handleMaxPossibleReturnError(response.data.data, selectedFreeBet?.freebetStake || 0);
				}

				this.setState({
					errorCode,
					betActionErrors: localbetActionErrors.length > 0 ? localbetActionErrors : response.data.data,
					betLoading: false,
				});
			}
		} catch (err) {
			this.setState({ betLoading: false });
			console.error('err', err);
		}
	};

	getApproveBets = async (body: any) => {
		try {
			const response = await BettingApi.approveBets(body);
			if (response.data.code !== 200) {
				const errorCode = response.data.data.map((item: any) => item.betSlipErrorCode) || [];
				this.setState({
					errorCode: [...errorCode],
					betLoading: false,
				});
				return false;
			} else {
				this.setState({
					errorCode: [BetslipErrors.SINGLE_SLIP_TO_ACCEPT_FOR_TRADER],
				});
			}
			return true;
		} catch (error) {
			return false;
		}
	};

	checkApprovedSlips = async () => {
		const userData = getUserDetails();
		this.setState({ approvedSlip: true });
		try {
			const response = await BettingApi.approvedSlips();
			const data: ApprovedBetSlipData = response.data.data.approvedSlipData;
			if (!isEmpty(data)) {
				if (data.status !== ApprovedBetSlipStatus.WAITING_FOR_RESPONSE) {
					const errorCodes = this.state.errorCode;
					errorCodes.splice(
						errorCodes.findIndex(
							(errorCode) =>
								errorCode === BetslipErrors.SINGLE_SLIP_TO_ACCEPT_FOR_TRADER ||
								errorCode === BetslipErrors.MULTI_SLIP_TO_ACCEPT_FOR_TRADER,
						),
						1,
					);
					clearInterval(this.approvedBetSlipInterval);
					this.setState({ errorCode: errorCodes, approvedSlip: false, betLoading: false });
					setDataLayer({
						...DATALAYER_PLACEBET_SUCCESS,
						...userData,
					});
				}
			}
			this.setState({ approvedBetSlipData: data });
		} catch (error) {}
	};

	closeApprovedBetSlipModal = () => {
		this.setState({ approvedBetSlipData: {} as ApprovedBetSlipData });
	};

	onCloseCongratsModal = () => {
		this.setState(
			{
				showCongratsModal: false,
				betLoading: true,
			},
			() => {
				this.filterFreeBets();
				this.props.addBet({ ...this.props.bets, isFreeBetSelected: false, freeBetStack: null, freebetId: null });
				this.setState({
					selectedFreeBet: '',
					betLoading: false,
					stackValue: this.props.bets.stake,
				});
			},
		);
	};

	onClickHomeRedirection = () => {
		this.props.history.goBack();
	};

	deleteTemporaryBets = () => {
		this.setState({ temporaryBets: [] });
	};

	setDefaultBetslipState = () => {
		this.props.addBet({ ...DefaultBetslipState, stake: this.props.bets.stake });
		this.props.handleBalanceData({ ...this.props.balanceData, selectedBalanceType: MAIN_BALANCE });
	};

	deleteAllBets = (coupon: CouponState) => {
		this.setState({
			temporaryBets: { ...this.props.bets },
		});

		this.setDefaultBetslipState();
		const allBets = this.props.bets.outcomes;
		removeBets(allBets);
	};

	handleIsCal = (value: boolean) => {
		this.setState({ isCal: value });
	};

	handelSelectedFreeBet = (id: string, stack: number) => {
		const isBonusBalanceSelected = this.props.balanceData.selectedBalanceType === BONUS_BALANCE && id === '';
		const isFreebetSelected = id !== '';
		const allBets = [...this.props.bets.blocks, ...this.props.bets.outcomes].flat();

		if (id !== '') {
			this.setState({
				selectedFreeBet: id,
				stackValue: stack,
				errorCode: [],
			});
			this.props.addBet({
				...this.props.bets,
				freebetId: parseInt(id),
				freeBetStack: stack,
				isFreeBetSelected: isFreebetSelected,
				bonusBet: false,
			});
			addNotification('success', `${this.props.t('freebetActivated')}!`);
		} else {
			this.setState({
				selectedFreeBet: id,
				stackValue: this.props.bets.stake,
				errorCode: [],
			});
			if (allBets.length) {
				this.props.addBet({
					...this.props.bets,
					stake: this.props.bets.stake,
					freebetId: null,
					freeBetStack: null,
					isFreeBetSelected: isFreebetSelected,
					bonusBet: isBonusBalanceSelected,
				});
			}
		}
	};
	deselectFreeBet = () => {
		this.setState({ selectedFreeBet: '' });
	};

	onCloseError = (error: number, indexOfErrorDetail: number) => {
		const errorCode = this.state.errorCode;
		const index = errorCode.findIndex((item) => error === item);
		errorCode.splice(index, 1);

		this.setState({ errorCode });

		if (this.state.betActionErrors) {
			const errorDetail = Object.values(this.state.betActionErrors);
			const index = errorDetail.findIndex((_, index) => index === indexOfErrorDetail);
			errorDetail.splice(index, 1);

			this.setState({ betActionErrors: errorDetail });
		}
	};

	handleIsRestoringBets = (isRestoring: boolean) => {
		this.setState({ isRestoringBets: isRestoring });
	};

	removeAllBets = (coupon: CouponState) => {
		this.deleteAllBets(coupon);
		this.handleIsRestoringBets(true);
		setDataLayer(BetslipEvents.BET_CANCEL(getAnalyticalData(coupon)));
	};

	render() {
		const {
			selectedCombination,
			showCongratsModal,
			stackValue,
			errorCode,
			freeBets,
			selectedFreeBet,
			betLoading,
			approvedSlip,
			approvedBetSlipData,
			betActionErrors,
		} = this.state;
		const { betStatics, loading, t, bets, balanceData, awaitingWinningResp, coupon } = this.props;

		const isBetslipEmpty = bets.outcomes.length === 0 && bets.blocks.length === 0;

		const isAkoBetTab = bets.betMode === AKO;
		const isSystemBetTab = bets.betMode === SYSTEM;
		return (
			<>
				{isMobile() && <FastPayment location={'mobile-coupon'} onReady={() => this.setState({ isFastPaymentReady: true })} />}
				<BottomDrawer
					className={`betslip__drawer showFastPayment ${this.state.isFastPaymentReady ? 'showFastPayment' : ''} `}
					isBottomDrawer={isMobile()}
					handleBottomDrawer={() => this.onClickHomeRedirection()}
					isDrawerHeader={true}
					heading={t('yourCoupon')}
					isDrawerClose={false}
					headerAction={
						<>
							{!this.state.isRestoringBets && !isBetslipEmpty && (
								<CouponRemoveAllButton removeAllBets={() => this.removeAllBets(coupon)} />
							)}
							{this.state.isRestoringBets && (
								<CouponUndoButton
									isRestoringBets={this.state.isRestoringBets}
									handleIsRestoringBets={this.handleIsRestoringBets}
									deleteTemporaryBets={this.deleteTemporaryBets}
									temporaryBets={this.state.temporaryBets}
									bets={bets}
									balanceData={balanceData}
									isBetslipEmpty={isBetslipEmpty}
								/>
							)}
						</>
					}
				>
					<MobileCouponBasket
						setStakeMethod={this.setStakeMethod}
						isCal={this.state.isCal}
						handleIsCal={this.handleIsCal}
						deselectFreeBet={this.deselectFreeBet}
						isBetslipEmpty={isBetslipEmpty}
						changeNavigationView={() => this.props.history.push(APP_URL.login, window.location.pathname)}
						betStatics={betStatics}
						onClickPlaceBet={this.onClickPlaceBet}
						outcomes={bets.outcomes}
						handleOddsChangeOption={this.handleOddsChangeOption}
						loading={loading}
						selectedCombination={selectedCombination}
						onChangeStackValue={this.onChangeStackValue}
						betLoading={betLoading}
						approvedSlip={approvedSlip}
						betMode={this.props.bets.betMode}
						selectedBalanceType={balanceData.selectedBalanceType}
						betType={this.props.bets.betType}
						freeBets={freeBets}
						blocks={bets.blocks}
						awaitingWinningResp={awaitingWinningResp}
						selectedFreeBet={selectedFreeBet}
						handelSelectedFreeBet={this.handelSelectedFreeBet}
						removeBet={this.removeBet}
						handelSelectedBet={this.handelSelectedBet}
						stackValue={stackValue}
						handleSelectedCombination={this.handleSelectedCombination}
						errorCode={errorCode}
						onCloseError={this.onCloseError}
						betActionErrors={betActionErrors}
						warnings={this.state.warnings}
						completedEvents={this.state.completedEvents}
						handleGroupChange={this.handleGroupChange}
						handleIsRestoringBets={this.handleIsRestoringBets}
						isAkoBetTab={isAkoBetTab}
						isSystemBetTab={isSystemBetTab}
						bets={bets}
						balanceData={balanceData}
						onChangeGameMode={this.onChangeGameMode}
						isRestoringBets={this.state.isRestoringBets}
						temporaryBets={this.state.temporaryBets}
						deleteTemporaryBets={this.deleteTemporaryBets}
						removeAllBets={() => this.removeAllBets(coupon)}
						handleHomeRedirection={() => this.onClickHomeRedirection()}
					/>
				</BottomDrawer>

				{!isMobile() && (
					<DesktopCouponBasket
						setStakeMethod={this.setStakeMethod}
						isCal={this.state.isCal}
						handleIsCal={this.handleIsCal}
						deselectFreeBet={this.deselectFreeBet}
						isBetslipEmpty={isBetslipEmpty}
						changeNavigationView={() => this.props.history.push(APP_URL.login, window.location.pathname)}
						betStatics={betStatics}
						onClickPlaceBet={this.onClickPlaceBet}
						outcomes={bets.outcomes}
						handleOddsChangeOption={this.handleOddsChangeOption}
						loading={loading}
						selectedCombination={selectedCombination}
						onChangeStackValue={this.onChangeStackValue}
						betLoading={betLoading}
						approvedSlip={approvedSlip}
						betMode={this.props.bets.betMode}
						selectedBalanceType={balanceData.selectedBalanceType}
						betType={this.props.bets.betType}
						freeBets={freeBets}
						blocks={bets.blocks}
						awaitingWinningResp={awaitingWinningResp}
						selectedFreeBet={selectedFreeBet}
						handelSelectedFreeBet={this.handelSelectedFreeBet}
						removeBet={this.removeBet}
						handelSelectedBet={this.handelSelectedBet}
						stackValue={stackValue}
						handleSelectedCombination={this.handleSelectedCombination}
						errorCode={errorCode}
						onCloseError={this.onCloseError}
						betActionErrors={betActionErrors}
						warnings={this.state.warnings}
						completedEvents={this.state.completedEvents}
						handleGroupChange={this.handleGroupChange}
						handleIsRestoringBets={this.handleIsRestoringBets}
						isAkoBetTab={isAkoBetTab}
						isSystemBetTab={isSystemBetTab}
						isRestoringBets={this.state.isRestoringBets}
						balanceData={balanceData}
						removeAllBets={this.removeAllBets}
						deleteTemporaryBets={this.deleteTemporaryBets}
						temporaryBets={this.state.temporaryBets}
						onChangeGameMode={this.onChangeGameMode}
						bets={bets}
						coupon={coupon}
					/>
				)}

				{!isEmpty(approvedBetSlipData) && approvedBetSlipData.status !== ApprovedBetSlipStatus.WAITING_FOR_RESPONSE && (
					<AcceptedBetSlipModal approvedBetSlipData={approvedBetSlipData} closeApprovedBetSlipModal={this.closeApprovedBetSlipModal} />
				)}

				{showCongratsModal && (
					<PlaceBetSuccessDialog
						setStakeMethod={this.setStakeMethod}
						bets={this.props.bets}
						betStatics={this.state.congratsModalBetStatics}
						onCloseCongratsModal={this.onCloseCongratsModal}
						deleteBets={() => {
							this.deleteAllBets(coupon);
						}}
					/>
				)}
				<InactiveUserDialog
					open={this.state.inactiveUserModalOpen}
					onClose={() => this.setState({ inactiveUserModalOpen: false })}
					mode="BASKET"
				/>
			</>
		);
	}
}

interface MapStateProps {
	betStatics: any;
	bets: BETSType;
	loading: boolean;
	balanceData: BalanceState;
	awaitingWinningResp: boolean;
	freebetsActive: Freebet[];
	coupon: CouponState;
}

const selectIsActionLoading = createIsActionLoadingSelector('CALCULATE_TAX');

const mapStateToProps = (state: State): MapStateProps => ({
	loading: selectIsActionLoading(state),
	betStatics: state.coupon.betStatics,
	awaitingWinningResp: state.coupon.awaitingWinningResp,
	bets: state.coupon.bets,
	balanceData: state.cpPanel.balanceData,
	freebetsActive: selectFreebetsActive(state),
	coupon: state.coupon,
});

interface DispatchProps {
	addBet: (params: BETSType) => void;
	calculateTax: () => void;
	handleBalanceData: (balanceData: BalanceState) => void;
	changeInBetOutcomes: (data: any) => void;
	removeFreeBetStack: () => void;
	createLoader: () => void;
	fetchInGameCouponCount: () => void;
	fetchBonusesAndFreebets: () => void;
}
const mapDispatchToProps = (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, Action>): DispatchProps => ({
	addBet: (params: BETSType) => dispatch(addBet(params)),
	calculateTax: () => dispatch(calculateTax()),
	handleBalanceData: (balanceData: BalanceState) => dispatch(handleBalanceData(balanceData)),
	changeInBetOutcomes: (data: any) => dispatch(changeInBetOutcomes(data)),
	removeFreeBetStack: () => dispatch(removeFreeBetStack()),
	createLoader: () => dispatch(createLoader()),
	fetchInGameCouponCount: () => dispatch(fetchInGameCouponCount()),
	fetchBonusesAndFreebets: () => dispatch(fetchBonusesAndFreebets()),
});

export default connect<MapStateProps, DispatchProps, Record<string, unknown>, State>(
	mapStateToProps,
	mapDispatchToProps,
)(withTranslation()(withRouter(CouponWithBets)));
